module.exports = __webpack_public_path__ + "img/customized_cost_calculation.8dbb45b1.svg";